var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgWalletSimple = function SvgWalletSimple(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.73.47A.72.72 0 0 0 8 0h-.17L6.6.32l-3.76.89H9ZM10.71 5.06a.48.48 0 0 0-.15-.28.37.37 0 0 0-.17-.1h-3.9a.51.51 0 0 0-.41.5v1.48a.49.49 0 0 0 .47.43h3.83a.48.48 0 0 0 .17-.1.53.53 0 0 0 .16-.38V5.06Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.37 6.58V5.15a1.26 1.26 0 0 1 .33-.85 1.15 1.15 0 0 1 .72-.37h3.66V2.3a.51.51 0 0 0-.15-.36.43.43 0 0 0-.32-.14H.48a.45.45 0 0 0-.37.2.61.61 0 0 0-.11.17.69.69 0 0 0 0 .13v7.17a.49.49 0 0 0 .48.53h9.13a.49.49 0 0 0 .47-.51V7.82H6.56a1.21 1.21 0 0 1-1.19-1.24Z"
  })));
};
export default SvgWalletSimple;